import type { DocBlock } from "./blockTypes";

export function sortDocBlocks(blocks: DocBlock[]): DocBlock[] {
  return [...blocks]
    .sort((a, b) => a.sort_order - b.sort_order)
    .map((block, index) => ({ ...block, sort_order: index }));
}

export function moveDocBlock(
  blocks: DocBlock[],
  blockId: string,
  direction: "up" | "down",
): DocBlock[] {
  const sorted = sortDocBlocks(blocks);
  const idx = sorted.findIndex((b) => b.id === blockId);
  if (idx < 0) return sorted;
  const swapWith = direction === "up" ? idx - 1 : idx + 1;
  if (swapWith < 0 || swapWith >= sorted.length) return sorted;
  const next = [...sorted];
  [next[idx], next[swapWith]] = [next[swapWith]!, next[idx]!];
  return next.map((block, index) => ({ ...block, sort_order: index }));
}

export function removeDocBlock(blocks: DocBlock[], blockId: string): DocBlock[] {
  return sortDocBlocks(blocks.filter((b) => b.id !== blockId));
}

export function updateDocBlock(blocks: DocBlock[], updated: DocBlock): DocBlock[] {
  return sortDocBlocks(blocks.map((b) => (b.id === updated.id ? updated : b)));
}
